/* eslint react/prop-types: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import COLORS from 'inventory-listing/constants/colors.js';

import 'inventory-listing/components/ListingFilters/Components/ListingFiltersColors/FiltersColor.scss';

const FiltersColor = ({ color, handleChange }) => {
    const filtersColors = ['filters-colors'];
    const colorClass = COLORS.find((mappedColor) => {
        return mappedColor.code === parseInt(color.code, 10);
    });

    const style = {};
    if (colorClass) {
        style.backgroundColor = colorClass.colorCode;
    }

    if (color.isSelected) {
        filtersColors.push('selected is-price');
    }

    const label = color.count > 0 ? `${color.label} (${color.count})` : color.label;

    return (
        <li className={filtersColors.join(' ')} title={label} style={style} onClick={() => handleChange(color.code)} />
    );
};

FiltersColor.propTypes = {
    color: PropTypes.shape({
        selected: PropTypes.bool,
        name: PropTypes.string,
        classe: PropTypes.string,
    }),
    handleChange: PropTypes.func.isRequired,
};

FiltersColor.displayName = 'FiltersColor';

export default FiltersColor;
